import { PieceAction, UpdatePiecesRequest } from '@apiContract';

interface BuildRequestDataParams {
  mailpieces: Array<{ id: number }>;
  action: PieceAction;
  isForce?: boolean;
  shouldNotify?: boolean;
  additionalData?: Record<string, any>;
}

export const buildUpdatePiecesRequest = ({
  mailpieces,
  action,
  isForce,
  shouldNotify,
  additionalData = {},
}: BuildRequestDataParams): UpdatePiecesRequest => {
  const requestData: UpdatePiecesRequest = {
    pieces: mailpieces.map((piece) => ({ id: Number(piece.id) })),
    action,
    isForce,
    ...additionalData,
  };

  if (isForce && shouldNotify !== undefined) {
    requestData.shouldNotify = shouldNotify;
  }

  return requestData;
};
